// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px) {
    .landing-bg {
        height: 100vh;
        padding: 0;
    }
}

@media (max-width: 992px) {
    .circle {
        height: 250px;
        width: 250px;
    }

    .triangle {
        border-left: 50px solid transparent;
        border-right: 50px solid transparent;
        border-bottom: 100px solid #416277;
    }
}

@media (max-width: 900px) {
    #sidebar-wrapper {
        width: 0 !important;
        padding: 0px;
        display: none;
    }

    #page-content-wrapper {
        margin-left: 0px;
        padding-left: 0px;
    }

    section {
        padding-right: 1.5rem;
        padding-left: 1.5rem;
    }

    nav.fixed-top {
        display: block;
    }

    .navbar {
        display: block;
    }

    .navigation-container {
        height: inherit;
    }

    .tabbed-navigation {
        background: transparent;
        padding-bottom: 5px;
    }

    .tab {
        padding: 0 12px;
    }

}`, "",{"version":3,"sources":["webpack://./src/css/media-queries.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;QACb,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,mCAAmC;QACnC,oCAAoC;QACpC,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["@media (min-width: 992px) {\r\n    .landing-bg {\r\n        height: 100vh;\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .circle {\r\n        height: 250px;\r\n        width: 250px;\r\n    }\r\n\r\n    .triangle {\r\n        border-left: 50px solid transparent;\r\n        border-right: 50px solid transparent;\r\n        border-bottom: 100px solid #416277;\r\n    }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    #sidebar-wrapper {\r\n        width: 0 !important;\r\n        padding: 0px;\r\n        display: none;\r\n    }\r\n\r\n    #page-content-wrapper {\r\n        margin-left: 0px;\r\n        padding-left: 0px;\r\n    }\r\n\r\n    section {\r\n        padding-right: 1.5rem;\r\n        padding-left: 1.5rem;\r\n    }\r\n\r\n    nav.fixed-top {\r\n        display: block;\r\n    }\r\n\r\n    .navbar {\r\n        display: block;\r\n    }\r\n\r\n    .navigation-container {\r\n        height: inherit;\r\n    }\r\n\r\n    .tabbed-navigation {\r\n        background: transparent;\r\n        padding-bottom: 5px;\r\n    }\r\n\r\n    .tab {\r\n        padding: 0 12px;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
